import React, {useState} from "react";
import {Field} from "react-final-form";
import FileUpload from "./FileUpload";
import Error from "../../../../common/components/elements/Error";
import styled from "styled-components";
import {getBase64Size} from "src/core/common/utils";
import {showErrorHighlight} from "src/core/common/utils";

function FileField({
  name,
  validate,
  image,
  initialImage,
  Placeholder,
  hasVerificationService,
  LabelComponent,
  className,
  ...props
}) {
  const [selectedImage, setSelectedImage] = useState(image);
  return (
    <Field name={name} validate={validate}>
      {({input: {value, onChange, ...input}, meta}) => {
        const handleChange = ({target, dataUri}) => {
          if (target && target.files) {
            onChange(target.files);
            setSelectedImage(URL.createObjectURL(target.files[0]));
          } else if (dataUri) {
            onChange([{data: dataUri, isDataUri: true, size: getBase64Size(dataUri)}]);
            setSelectedImage(dataUri);
          }
        };
        return (
          <Container className={className}>
            <FileUpload
              {...input}
              image={selectedImage}
              initialImage={initialImage}
              Placeholder={Placeholder}
              type="file"
              hasErrors={showErrorHighlight(meta)}
              onChange={handleChange}
              selectedValue={value}
              hasVerificationService={hasVerificationService}
              LabelComponent={LabelComponent}
              {...props}
            />
            {meta.touched && <Error>{meta.error}</Error>}
          </Container>
        );
      }}
    </Field>
  );
}

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  max-width: 50%;
`;

export default FileField;
